import { metadataInterface } from '../../interfaces/metadataInterface';
import Select from 'anchor-ui/select';
import MenuItem from 'anchor-ui/menu-item';
import { checkUserIsRoyal, checkUserIsVIPOrRoyal } from '../../utils/checkSubscription';
import { getFontStyle } from '../../utils/getFontStyle';
import GoogleAdSense from '../GoogleAdSense';
import { getSecondaryColor } from '../../utils/activeColor';
import Card from 'anchor-ui/card';

const PrivacyPage = ({
  visibility,
  changeVisibility,
  userProfile,
  handleUpdateUserMetadata,
  loggedInUser,
  setNeedSubscriptionWarning,
}: {
  visibility: string;
  changeVisibility: (visibility: string) => void;
  userProfile: metadataInterface;
  handleUpdateUserMetadata: (newMetadata: metadataInterface) => void;
  loggedInUser: CometChat.User;
  setNeedSubscriptionWarning: (warning: JSX.Element) => void;
}) => {

  const handleChange = (event: object, value: string) => {
    const newMetadata = { ...userProfile };
    newMetadata.callStatus = value;
    handleUpdateUserMetadata(newMetadata);
  };

  const handleGalleryChange = (event: object, value: string) => {
    if (checkUserIsVIPOrRoyal(loggedInUser?.getRole() ?? "")) {
      const newMetadata = { ...userProfile };
      if (!newMetadata.settings) {
        return;
      }
      newMetadata.settings.galleryVis = value;
      handleUpdateUserMetadata(newMetadata);
      return;
    }

    setNeedSubscriptionWarning(
      <b style={getFontStyle("")}>Upgrade naar VIP of Royal om deze instelling te gebruiken.</b>
    );
  }

  return (
    <>
      <Card style={{ height: '100%', width: '100%', backgroundColor: getSecondaryColor() }}>
        <GoogleAdSense
          adSlot="4191716780"
          style={{ display: 'inline-block', width: "984px", height: "121px" }}
          isRoyal={checkUserIsRoyal(loggedInUser?.getRole() ?? "")}
        />
      </Card>
      <br />

      <div className="flex">
        <div className="responsive-ad">
          <GoogleAdSense
            adSlot="6594518847"
            style={{ display: 'inline-block', width: "121px", height: "984px", paddingRight: "16px" }}
            isRoyal={checkUserIsRoyal(loggedInUser?.getRole() ?? "")}
          />
        </div>

        <div>
          <h2>Privacy</h2>
          <section className="account-input">
            <Select
              label="Profiel zichtbaarheid"
              value={visibility}
              onChange={(event: object, value: string) => {
                changeVisibility(value);

                // Ensure settings object exists
                const newMetadata = { ...userProfile };
                if (!newMetadata.settings) {
                  newMetadata.settings = {}; // Initialize settings if undefined
                }
                newMetadata.settings.profileVisibility = value;

                handleUpdateUserMetadata(newMetadata);
              }}
            >
              <MenuItem text="Openbaar" value="public" />
              <MenuItem text="Privé" value="private" />
              <MenuItem text="Alleen vrienden" value="friends" />
            </Select>
            {
              visibility === "private" ? (
                <p>Je profiel is privé. Andere gebruikers kunnen jouw profiel niet bekijken.</p>
              ) : visibility === "friends" ? (
                <p>Je profiel is alleen zichtbaar voor vrienden.</p>
              ) : (
                <p
                  style={getFontStyle("")}
                >
                  Je profiel is zichtbaar voor iedereen.
                </p>
              )
            }

            <br />
            <section className="setting-select">
              <Select
                label="Wie mag je bellen?"
                value={userProfile.callStatus ?? "Iedereen"}
                onChange={handleChange}
              >
                <MenuItem text="Iedereen" value="" />
                <MenuItem text="Alleen vrienden" value="call_only_friends" />
                <MenuItem text="Niemand" value="dnd" />
              </Select>
            </section>

            <br />
            <h2>VIP</h2>
            <section className="setting-select">
              <Select
                label="Wie mag je galerij zien?"
                value={userProfile.settings?.galleryVis === "public" ? "" : userProfile.settings?.galleryVis ?? ""}
                onChange={handleGalleryChange}
              >
                <MenuItem text="Iedereen" value="" />
                <MenuItem text="Alleen vrienden" value="friends" />
                <MenuItem text="Niemand" value="private" />
              </Select>
            </section>

          </section>
        </div>

      </div>
    </>
  );
}

export default PrivacyPage;
